/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ratelimitLimit } from "../../funcs/ratelimitLimit.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.V2RatelimitLimitRequestBody$inboundSchema,
};

export const tool$ratelimitLimit: ToolDefinition<typeof args> = {
  name: "ratelimit-limit",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await ratelimitLimit(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
